import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import CustomHref from "../../../components/core/blocks/CustomHref";
import { snakeCaseToSentenceCase } from "../../../utils/formatText";

interface ConnectSecondaryChannelWidgetProps {
  secondaryChannel?: string;
  linkToSummaryView?: string;
  onClick?: () => void | Promise<void>;
}

const ConnectSecondaryChannelWidget = ({
  secondaryChannel = "walmart",
  linkToSummaryView,
  onClick,
}: ConnectSecondaryChannelWidgetProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation(["onboarding"]);

  return (
    <div>
      <p>
        {t(($) => $.onboarding["Looking to connect your {channel} accounts?"], {
          channel: snakeCaseToSentenceCase(secondaryChannel),
        })}{" "}
        <CustomHref
          text={
            <span
              className="fs-3"
              onClick={async () => {
                if (onClick && typeof onClick === "function") {
                  await onClick();
                }
                if (linkToSummaryView) {
                  if (linkToSummaryView.includes("secondaryChannel")) {
                    localStorage.setItem("secondaryChannel", secondaryChannel);
                  }
                  void navigate({ href: linkToSummaryView });
                }
              }}
            >
              {t(($) => $.onboarding["Click Here"])}
            </span>
          }
        />
      </p>
    </div>
  );
};

export default ConnectSecondaryChannelWidget;
